import { css, LitElement, svg } from 'lit-element';
import { withDefer } from '../hocs/with-defer';

export class UcCircularLoader extends LitElement {
  static get styles() {
    return css`
      :host {
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
        animation: rotate 2s linear infinite;
      }

      .circular {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        margin: auto;
        transform-origin: center center;
        animation: rotate 2s linear infinite;
      }

      .path {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
        animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
        stroke-linecap: round;
        stroke: #a9acb1;
      }

      @keyframes rotate {
        100% {
          transform: rotate(360deg);
        }
      }

      @keyframes dash {
        0% {
          stroke-dasharray: 1, 200;
          stroke-dashoffset: 0;
        }
        50% {
          stroke-dasharray: 89, 200;
          stroke-dashoffset: -35px;
        }
        100% {
          stroke-dasharray: 89, 200;
          stroke-dashoffset: -124px;
        }
      }
    `;
  }

  render() {
    return svg`
      <svg class="circular" viewBox="25 25 50 50"><circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle></svg>
    `;
  }
}

export const Enchanced = withDefer(UcCircularLoader);
